
import EditComponent from "../../../components/members/Edit.vue";

export default {
  components: {
    EditComponent
  }
};
